package com.milta.core.localization

import androidx.compose.runtime.staticCompositionLocalOf
import cafe.adriel.lyricist.LanguageTag
import com.milta.core.localization.translations.en.EnStrings
import com.milta.core.localization.translations.fr.FrStrings
import com.milta.core.localization.translations.nl.NlStrings
import com.milta.core.localization.translations.ro.RoStrings
import com.milta.core.localization.translations.bg.BgStrings
import com.milta.core.localization.translations.sq.SqStrings
import com.milta.core.localization.translations.pl.PlStrings
import com.milta.core.localization.translations.it.ItStrings
import com.milta.core.localization.translations.es.EsStrings
import com.milta.core.localization.translations.de.DeStrings

data class AppStrings(
    val common: CommonStrings,
    val auth: AuthStrings,
    val errors: ErrorStrings,
    val home: HomeStrings,
    val profile: ProfileStrings,
    val subscription: SubscriptionStrings,
    val route: RouteStrings,
    val team: TeamStrings,
    val subscriptionExpired: SubscriptionExpiredStrings,
    val imports: ImportsStrings,
    val ocrScan: OcrScanStrings,
    val packageLabelScan: PackageLabelScanStrings,
    val spreadsheetImport: SpreadsheetImportStrings,
    val webImportRoute: WebImportRouteStrings,
    val settings: SettingsStrings,
    val webDashboard: WebDashboardStrings,
    val webHistorique: WebHistoriqueStrings,
)

val Strings: Map<LanguageTag, AppStrings> = mapOf(
    "fr" to FrStrings,
    "nl" to NlStrings,
    "en" to EnStrings,
    "ro" to RoStrings,
    "bg" to BgStrings,
    "sq" to SqStrings,
    "pl" to PlStrings,
    "it" to ItStrings,
    "es" to EsStrings,
    // MIL-53 — Dashboard Web "Paramètres" language picker only (10 languages); Driver mobile
    // language selection (ProfileScreen) intentionally still offers only the original 9 — German
    // is not a supported Chauffeur-side preference by this ticket's explicit scope.
    "de" to DeStrings,
)

val supportedLanguages: Set<LanguageTag> = Strings.keys.toSet()

fun resolveLanguageTag(systemTag: String): LanguageTag =
    if (systemTag in supportedLanguages) systemTag else "en"

val LocalStrings = staticCompositionLocalOf { EnStrings }
